import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import Header from "./components/Header"; // Import Header component
import QueryPage from "./components/QueryPage"; // Import QueryPage component
import Translate from "./components/Translate"; // Import Translate component
import JudgeView from "./components/JudgeView"; // Import JudgeView component
import LawyerView from "./components/LawyerView"; // Import LawyerView component
import Home from "./components/Home";
import Docai from "./components/Docai";
import SignUp from "./components/Signup";
import SignIn from "./components/SignIn";
import AvailableDocuments from "./components/AvailableDocuments";
import Drafts from "./components/Drafts";
import AdvDiary from "./components/AdvDiary";
import PrivateRoute from "./components/PrivateRoutes"; // Import PrivateRoute
import Pricing from "./components/pricing";
import Dashboard from "./components/Dashboard";
import TranslatePage from "./components/Translate";
import DraftsPage from "./components/Drafts";
import DocaiPage from "./components/Docai";
import AvailableDocumentsPage from "./components/AvailableDocuments";
import AdvDiaryPage from "./components/AdvDiary";
import QueryBotPage from "./components/QueryPage";
import DashboardHome from "./components/DashboardHome";
import ClerkRedirect from "./components/ClerkRedirect";


const PublicHomeRoute = () => (
  <>
    <SignedIn>
      <Navigate to="/dashboard" replace />
    </SignedIn>
    <SignedOut>
      <Home />
    </SignedOut>
  </>
);

const AppRoutes = () => {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!isDashboard && <Header />}
      <Routes>
        {/* Route for the home page */}
        <Route path="/idk" element={<Translate />} />
        <Route path="/" element={<PublicHomeRoute />} />
        <Route path="/home" element={<PublicHomeRoute />} />
        <Route path="/available-documents" element={<AvailableDocuments />} />
        {/* Route for QueryPage */}
        <Route path="/query-page" element={<QueryPage />} />
        <Route path="/doc.ai" element={<Docai />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/adv.diary" element={<AdvDiary />} />
        <Route path="/pricing" element={<Pricing />} />
        
        {/* Clerk redirect route */}
        <Route path="/redirect" element={<ClerkRedirect />} />

        {/* Protected Dashboard with nested routes */}
        <Route 
          path="/dashboard" 
          element={
            <>
              <SignedIn>
                <Dashboard />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="translate" element={<TranslatePage />} />
          <Route path="drafts" element={<DraftsPage />} />
          <Route path="docai" element={<DocaiPage />} />
          <Route path="available-documents" element={<AvailableDocumentsPage />} />
          <Route path="adv-diary" element={<AdvDiaryPage />} />
          <Route path="query" element={<QueryBotPage />} />
        </Route>

        {/* Protected Routes */}
        <Route
          path="/client-view"
          element={
            <PrivateRoute>
              <JudgeView />
            </PrivateRoute>
          }
        />

        <Route
          path="/lawyer-view"
          element={
            <PrivateRoute>
              <LawyerView />
            </PrivateRoute>
          }
        />
        <Route
          path="/drafts"
          element={
            <PrivateRoute>
              <Drafts />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
